export class EventEmitter {
  constructor() {
    this.listeners = new Map();
  }
  on(event, listener) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, [listener]);
      return;
    }
    const currentHandlerArray = this.listeners.get(event);
    this.listeners.set(event, [...currentHandlerArray, listener]);
  }
  off(event) {
    this.listeners.delete(event);
  }
  emit(event, data) {
    const callbackArray = this.listeners.get(event);
    if (!callbackArray || !callbackArray.length) {
      return;
    }
    callbackArray.forEach(handler => handler(data));
  }
  reset() {
    this.listeners = new Map();
  }
}
export function createEventEmitter() {
  return new EventEmitter();
}